module.exports = __webpack_public_path__ + "img/VillaLoreto_Room.84197526.jpg";